import styled from 'styled-components';

const SectionWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: ${({ theme }) => theme.grid.columnGap} 0;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    grid-gap: ${({ theme }) => theme.grid.columnGap};
  }
`;

export default SectionWrapper;
